module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping-list/shopping-list.component.css
// module id = ./src/app/shopping-list/shopping-list.component.css
// module chunks = main